export default {
    platform: "平台",
    home: "首页",
    index: "主页",
    menu: "菜单",
    video: "视频",
    login: "登录",
    username: "用户名",
    password: "密码",
    remember_me: "记住密码",
    change_password: "修改密码",
    logout: "退出登录",
    search: "搜索",
    id: "编号",
    sn: "序列号",
    view: "查看",
    created_time: "添加时间",
    shop: {
        name: "门店"
    },
    device: {
        device_manage: "设备管理",
        device_list: "设备列表",
        bind_shop: "绑定门店",
        device_type: "设备类型",
        bind_time: "绑定时间",
        bind: "绑定",
        cancel_bind: "取消绑定",
        qrcode: "二维码"
    },
    dealer: {
        dealer_login: "经销商登录",
        dealer_management_system: "经销商管理系统"
    },
    message: {
        welcome: "欢迎光临！",
        please_enter_username: "请输入用户名",
        please_enter_password: "请输入密码",
        please_enter_id: "请输入编号",
        please_enter_sn: "请输入序列号",
        please_select: "请选择"
    }
}


// WEBPACK FOOTER //
// ./src/lang/zh_CN.js